import React, { useEffect, useState, useRef } from 'react';
export function PromoHero() {
  const [secondsLeft, setSecondsLeft] = useState(900);
  const [liveCount, setLiveCount] = useState(() => Math.floor(Math.random() * 11) + 105);
  const [offerSecondsLeft, setOfferSecondsLeft] = useState(900);
  const [liveCount2, setLiveCount2] = useState(() => Math.floor(Math.random() * 11) + 105);
  const [spotsLeft] = useState(() => Math.floor(Math.random() * 9) + 7);
  const [playingVideo1, setPlayingVideo1] = useState(false);
  const [playingVideo2, setPlayingVideo2] = useState(false);
  const testimonialRef1 = useRef<HTMLVideoElement>(null);
  const testimonialRef2 = useRef<HTMLVideoElement>(null);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsLeft <= 0]);
  useEffect(() => {
    const tick = () => {
      const delay = (Math.floor(Math.random() * 2) + 2) * 1000;
      const timeout = setTimeout(() => {
        setLiveCount(prev => {
          const delta = (Math.floor(Math.random() * 2) + 1) * (Math.random() < 0.5 ? -1 : 1);
          return Math.min(120, Math.max(100, prev + delta));
        });
        tick();
      }, delay);
      return timeout;
    };
    const timeout = tick();
    return () => clearTimeout(timeout);
  }, []);
  // Offer card countdown
  useEffect(() => {
    if (offerSecondsLeft <= 0) return;
    const interval = setInterval(() => {
      setOfferSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [offerSecondsLeft <= 0]);
  // Second live count
  useEffect(() => {
    const tick = () => {
      const delay = (Math.floor(Math.random() * 2) + 2) * 1000;
      const timeout = setTimeout(() => {
        setLiveCount2(prev => {
          const delta = (Math.floor(Math.random() * 2) + 1) * (Math.random() < 0.5 ? -1 : 1);
          return Math.min(120, Math.max(100, prev + delta));
        });
        tick();
      }, delay);
      return timeout;
    };
    const timeout = tick();
    return () => clearTimeout(timeout);
  }, []);
  const minutes = Math.floor(secondsLeft / 60).toString().padStart(2, '0');
  const seconds = (secondsLeft % 60).toString().padStart(2, '0');
  const offerMinutes = Math.floor(offerSecondsLeft / 60).toString().padStart(2, '0');
  const offerSeconds = (offerSecondsLeft % 60).toString().padStart(2, '0');
  const weekday = new Date().toLocaleDateString('es-AR', {
    weekday: 'long'
  });
  const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
  return <>
      {/* Sticky Promo Banner */}
      <div className="fixed top-0 left-0 right-0 z-50 py-2 px-3 text-center" style={{
      backgroundColor: '#0B0B0B',
      borderBottom: '1px solid #F97316'
    }} data-id="element-2">
        <p className="text-white text-sm font-semibold tracking-wide" data-id="element-3">
          🔥 Oferta Flash Hoy{' '}
          <span style={{
          color: '#F97316'
        }} data-id="element-4">
            {capitalizedWeekday}
          </span>
        </p>

        <p className="text-white text-sm mt-1" data-id="element-5">
          ⏳ Termina en:{' '}
          <span className="font-mono font-bold text-base" style={{
          color: '#F97316'
        }} data-id="element-6">
            {minutes}:{seconds}
          </span>
        </p>

        <a href="https://infoliar.com/cart/56769365606732:1" className="mt-2 w-full sm:w-auto sm:px-8 py-2 text-base font-extrabold uppercase rounded-lg border-0 cursor-pointer transition-opacity duration-200 hover:opacity-90 active:opacity-80 inline-block text-center no-underline" style={{
        backgroundColor: '#FFFFFF',
        color: '#000000',
        boxShadow: '0 0 15px rgba(249, 115, 22, 0.6), 0 0 30px rgba(249, 115, 22, 0.4), 0 0 60px rgba(249, 115, 22, 0.2)',
        animation: 'breathe-banner 2.5s ease-in-out infinite'
      }} data-id="element-7">
          QUIERO ACCEDER AHORA
        </a>
      </div>

      {/* Hero Image Section */}
      <section className="pt-[130px] sm:pt-[120px]" data-id="element-8">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771965159/3_1_nfnk9c.webp" alt="" className="w-full block object-cover" data-id="element-9" />
      </section>

      {/* New Content Section */}
      <section className="w-full px-4 py-4 flex flex-col items-center gap-3" style={{
      backgroundColor: '#0B0B0B'
    }} data-id="element-10">
        {/* A) White CTA Button with orange glow */}
        <a href="https://infoliar.com/cart/56769365606732:1" className="w-full sm:w-auto sm:px-12 py-3 text-base font-extrabold uppercase rounded-full border-0 cursor-pointer transition-transform duration-150 hover:scale-[1.03] active:scale-[0.97] inline-block text-center no-underline" style={{
        backgroundColor: '#FFFFFF',
        color: '#000000',
        boxShadow: '0 0 20px rgba(249, 115, 22, 0.6), 0 0 40px rgba(249, 115, 22, 0.45), 0 0 70px rgba(249, 115, 22, 0.25), 0 0 100px rgba(249, 115, 22, 0.1)'
      }} data-id="element-11">
          QUIERO LOS +600 PLANOS
        </a>

        {/* B) Live Viewer Indicator */}
        <div className="flex items-center justify-center gap-1.5 mt-0" data-id="element-12">
          <span className="block w-2 h-2 rounded-full flex-shrink-0" style={{
          backgroundColor: '#22C55E',
          animation: 'pulse-dot 2s ease-in-out infinite'
        }} aria-hidden="true" data-id="element-13" />
          <p className="text-white text-xs" data-id="element-14">
            <span className="font-semibold tabular-nums inline-block min-w-[3ch] text-center" data-id="element-15">
              {liveCount}
            </span>{' '}
            personas están viendo esto ahora mismo
          </p>
        </div>

        {/* C) Badges Row */}
        <div className="flex flex-wrap items-center justify-center gap-1.5" data-id="element-16">
          <span className="px-2 py-1 text-white text-[11px] rounded-full bg-white/10" data-id="element-17">
            ✅ Garantía 30 días
          </span>
          <span className="px-2 py-1 text-white text-[11px] rounded-full bg-white/10" data-id="element-18">
            ⚡ Acceso inmediato
          </span>
          <span className="px-2 py-1 text-white text-[11px] rounded-full bg-white/10" data-id="element-19">
            📐 +600 planos
          </span>
          <span className="px-2 py-1 text-white text-[11px] rounded-full bg-white/10" data-id="element-20">
            🔒 Pago seguro
          </span>
        </div>

        {/* D) Rating Block */}
        <div className="flex flex-col items-center gap-0.5" data-id="element-21">
          <div className="flex gap-0.5" aria-label="4.9 de 5 estrellas" data-id="element-22">
            <span style={{
            color: '#FACC15'
          }} className="text-base" data-id="element-23">
              ★
            </span>
            <span style={{
            color: '#FACC15'
          }} className="text-base" data-id="element-24">
              ★
            </span>
            <span style={{
            color: '#FACC15'
          }} className="text-base" data-id="element-25">
              ★
            </span>
            <span style={{
            color: '#FACC15'
          }} className="text-base" data-id="element-26">
              ★
            </span>
            <span style={{
            color: '#FACC15'
          }} className="text-base" data-id="element-27">
              ★
            </span>
          </div>
          <p className="text-white font-bold text-xs" data-id="element-28">4,9 estrellas</p>
          <p className="text-zinc-400 text-xs" data-id="element-29">+2.400 herreros ya accedieron</p>
        </div>

        {/* E) Closing Image */}
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771965159/4_cmuzi6.webp" alt="" className="w-full block object-cover rounded-xl" data-id="element-30" />
      </section>

      {/* Restored Video + Image Section */}
      <section className="w-full flex flex-col px-4 py-6 gap-4" style={{
      backgroundColor: '#000000'
    }} data-id="element-31">
        {/* 1) Video */}
        <video className="w-full block object-cover rounded-xl" src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1771513612/58cdb96a46734ee7b8eed1850976ceb4_ljcpjn.mp4" autoPlay muted loop playsInline preload="metadata" data-id="element-32" />

        {/* 2) Image */}
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771513611/3_3_iwbdre.jpg" alt="" className="w-full block object-cover rounded-xl" data-id="element-33" />
      </section>

      {/* Video + Images Section */}
      <section className="w-full flex flex-col px-4 py-6 gap-4" style={{
      backgroundColor: '#000000'
    }} data-id="element-34">
        {/* 1) Video */}
        <video className="w-full block object-cover rounded-xl" src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1771513939/ead673babfa846e1a92fabb7cb5f0a39_pjw3jf.mp4" autoPlay muted loop playsInline preload="metadata" data-id="element-35" />

        {/* 2) Closing Image */}
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771513930/4_3_ib7i5o.jpg" alt="" className="w-full block object-cover rounded-xl" data-id="element-36" />
      </section>

      {/* Full-Bleed Image + Video Section */}
      <section className="w-full" style={{
      backgroundColor: '#000000'
    }} data-id="element-37">
        <div className="w-full rounded-2xl overflow-hidden" data-id="element-38">
          {/* 1) Image */}
          <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771516214/LANDING_HERRERO_2_wrcenm.png" alt="" className="w-full block object-cover" data-id="element-39" />

          {/* 2) Video */}
          <video className="w-full block object-cover" src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1771516257/77b6474dbe144098a2ab51a577d471b1_te4blm.mp4" autoPlay muted loop playsInline preload="metadata" data-id="element-40" />
        </div>
      </section>

      {/* ===== PRODUCT SECTION ===== */}
      <section className="w-full flex flex-col items-center" style={{
      backgroundColor: '#000000'
    }} data-id="element-41">
        {/* 1) Product Image */}
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771516967/Disenosintitulo_35_1_tt88ea.png" alt="" className="w-full block object-cover" data-id="element-42" />

        {/* 2-8) Content block */}
        <div className="w-full px-4 py-4 flex flex-col items-center gap-3" data-id="element-43">
          {/* 2) Download count */}
          <p className="text-white text-xs text-center" data-id="element-44">+5.200 descargas</p>

          {/* 3) Title */}
          <h2 className="text-white text-lg font-bold text-center leading-tight" data-id="element-45">
            Sistema Maestro de Herrería +{' '}
            <span style={{
            color: '#F97316'
          }} data-id="element-46">
              8 Bonus
            </span>{' '}
            de Regalo 🎁
          </h2>

          {/* 4) Price Card */}
          <div className="w-full rounded-xl p-4 flex flex-col items-center gap-2" style={{
          backgroundColor: '#000000',
          border: '1px solid #F97316',
          boxShadow: '0 0 25px rgba(249, 115, 22, 0.5), 0 0 50px rgba(249, 115, 22, 0.3), 0 0 80px rgba(249, 115, 22, 0.15)'
        }} data-id="element-47">
            <p className="text-zinc-500 line-through text-[18px] font-[600]" data-id="element-48">
              52.95€
            </p>
            <p className="font-extrabold text-[36px]" style={{
            color: '#22C55E'
          }} data-id="element-49">
              12.95€
            </p>
            <p className="font-bold px-3 py-1 rounded-md text-[12px] text-[#FFFFFF]" style={{
            textShadow: '0 0 12px rgba(34, 197, 94, 0.6), 0 0 24px rgba(34, 197, 94, 0.3)'
          }} data-id="element-50">
              AHORRA 50€
            </p>
            <div className="w-full h-px bg-white/10 my-1" data-id="element-51" />
            <p className="text-white text-xs text-center" data-id="element-52">
              🔐 Compra segura  | ⚡ Acceso instantáneo
            </p>
          </div>

          {/* 5) Offer Card */}
          <div className="w-full rounded-xl p-4 flex flex-col items-center gap-2" style={{
          backgroundColor: '#000000',
          border: '1px solid #F97316',
          boxShadow: '0 0 25px rgba(249, 115, 22, 0.5), 0 0 50px rgba(249, 115, 22, 0.3), 0 0 80px rgba(249, 115, 22, 0.15)'
        }} data-id="element-53">
            <p className="text-base font-extrabold uppercase tracking-wide" style={{
            color: '#22C55E'
          }} data-id="element-54">
              ¡OFERTA SOLO POR HOY!
            </p>
            <p className="text-white text-xs text-center leading-relaxed font-[400]" data-id="element-55">
              Tu lugar con los 8 bonos de regalo solo está reservado por los
              próximos minutos. No pierdas tus beneficios.
            </p>
            <p className="text-white text-xs mt-1" data-id="element-56">La oferta se termina en:</p>
            <p className="font-mono font-bold text-2xl" style={{
            color: '#22C55E'
          }} data-id="element-57">
              {offerMinutes}:{offerSeconds}
            </p>
            <p className="text-sm font-bold" style={{
            color: '#22C55E',
            textShadow: '0 0 12px rgba(34, 197, 94, 0.6), 0 0 24px rgba(34, 197, 94, 0.3)'
          }} data-id="element-58"></p>
          </div>

          {/* 6) Live Viewer Count */}
          <div className="flex items-center justify-center gap-1.5" data-id="element-59">
            <span className="block w-2 h-2 rounded-full flex-shrink-0" style={{
            backgroundColor: '#22C55E',
            animation: 'pulse-dot 2s ease-in-out infinite'
          }} aria-hidden="true" data-id="element-60" />
            <p className="text-white text-xs" data-id="element-61">
              <span className="font-semibold tabular-nums inline-block min-w-[3ch] text-center" data-id="element-62">
                {liveCount2}
              </span>{' '}
              personas están viendo esta oferta ahora mismo
            </p>
          </div>

          {/* 7) Limited Spots */}
          <div className="flex items-center justify-center gap-1.5" data-id="element-63">
            <span className="block w-2 h-2 rounded-full flex-shrink-0" style={{
            backgroundColor: '#EF4444',
            boxShadow: '0 0 6px rgba(239, 68, 68, 0.6)',
            animation: 'pulse-red 2s ease-in-out infinite'
          }} aria-hidden="true" data-id="element-64" />
            <p className="text-white text-xs font-semibold" data-id="element-65">
              Últimos <span className="tabular-nums" data-id="element-66">5</span> cupos disponibles
            </p>
          </div>

          {/* 8) Final CTA Button */}
          <a href="https://infoliar.com/cart/56769365606732:1" className="w-full py-3.5 text-base uppercase rounded-full border-0 cursor-pointer block text-center no-underline" style={{
          backgroundColor: '#22C55E',
          color: '#FFFFFF',
          fontWeight: 800,
          boxShadow: '0 4px 15px rgba(34, 197, 94, 0.4)',
          animation: 'breathe 2.5s ease-in-out infinite'
        }} data-id="element-67">
            ACCEDER AL SISTEMA YA MISMO
          </a>
        </div>
      </section>

      {/* ===== FULL-BLEED IMAGE GALLERY ===== */}
      <section className="w-full flex flex-col" style={{
      backgroundColor: '#000000'
    }} data-id="element-68">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771518480/5_3_hrosyb.jpg" alt="" className="w-full block object-cover" data-id="element-69" />
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771518480/6_4_vohaf7.jpg" alt="" className="w-full block object-cover" data-id="element-70" />
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771518480/LANDING_HERRERO_71d3ecf7-7d02-4e31-9399-56375d7aaf62_oywhke.jpg" alt="" className="w-full block object-cover" data-id="element-71" />
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771518481/LANDING_HERRERO_1_iklxtu.jpg" alt="" className="w-full block object-cover" data-id="element-72" />
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771518480/9_1_gwzyen.jpg" alt="" className="w-full block object-cover" data-id="element-73" />
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771518480/10_mrqqeq.jpg" alt="" className="w-full block object-cover" data-id="element-74" />
      </section>

      {/* ===== TESTIMONIALS SECTION ===== */}
      {/* 1) Guarantee Image */}
      <section className="w-full" style={{
      backgroundColor: '#000000'
    }} data-id="element-75">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771519359/11_svhilw.jpg" alt="" className="w-full block object-cover" data-id="element-76" />
      </section>

      {/* 2) White Testimonial Header */}
      <section className="w-full py-6 flex flex-col items-center gap-1" style={{
      backgroundColor: '#FFFFFF'
    }} data-id="element-77">
        <div className="flex gap-0.5" data-id="element-78">
          <span className="text-lg" style={{
          color: '#FACC15'
        }} data-id="element-79">
            ★
          </span>
          <span className="text-lg" style={{
          color: '#FACC15'
        }} data-id="element-80">
            ★
          </span>
          <span className="text-lg" style={{
          color: '#FACC15'
        }} data-id="element-81">
            ★
          </span>
          <span className="text-lg" style={{
          color: '#FACC15'
        }} data-id="element-82">
            ★
          </span>
          <span className="text-lg" style={{
          color: '#FACC15'
        }} data-id="element-83">
            ★
          </span>
        </div>
        <h2 className="text-black text-xl font-extrabold uppercase tracking-wide" data-id="element-84">
          RESULTADOS REALES
        </h2>
        <p className="text-zinc-500 text-sm" data-id="element-85">Alumnos que ya están facturando</p>
      </section>

      {/* 3) Video Grid */}
      <section className="w-full px-4 py-6" style={{
      backgroundColor: '#0B0B0B'
    }} data-id="element-86">
        <div className="grid grid-cols-2 gap-2.5" data-id="element-87">
          {/* Video 1 */}
          <div className="relative rounded-xl overflow-hidden" style={{
          aspectRatio: '9/16',
          boxShadow: '0 0 25px rgba(249, 115, 22, 0.5), 0 0 50px rgba(249, 115, 22, 0.3), 0 0 80px rgba(249, 115, 22, 0.15)'
        }} data-id="element-88">
            <video ref={testimonialRef1} className="w-full h-full object-cover block" src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1771519371/714acfc386434a679349913d347f6be7_uth6t4.mov" autoPlay muted loop playsInline preload="auto" controls={playingVideo1} data-id="element-89" />
            {!playingVideo1 && <button className="absolute inset-0 flex items-center justify-center bg-transparent border-0 cursor-pointer" onClick={() => {
            const vid = testimonialRef1.current;
            if (vid) {
              vid.muted = false;
              vid.currentTime = 0;
              vid.loop = false;
              vid.play();
            }
            setPlayingVideo1(true);
          }} aria-label="Reproducir video con sonido" data-id="element-90">
                <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(249, 115, 22, 0.85)',
              boxShadow: '0 0 20px rgba(249, 115, 22, 0.6)'
            }} data-id="element-91">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white" data-id="element-92">
                    <polygon points="8,5 20,12 8,19" data-id="element-93" />
                  </svg>
                </div>
              </button>}
          </div>

          {/* Video 2 */}
          <div className="relative rounded-xl overflow-hidden" style={{
          aspectRatio: '9/16',
          boxShadow: '0 0 25px rgba(249, 115, 22, 0.5), 0 0 50px rgba(249, 115, 22, 0.3), 0 0 80px rgba(249, 115, 22, 0.15)'
        }} data-id="element-94">
            <video ref={testimonialRef2} className="w-full h-full object-cover block" src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1771519371/26345de35dc9477390f620733f621291_m6nfpu.mov" autoPlay muted loop playsInline preload="auto" controls={playingVideo2} data-id="element-95" />
            {!playingVideo2 && <button className="absolute inset-0 flex items-center justify-center bg-transparent border-0 cursor-pointer" onClick={() => {
            const vid = testimonialRef2.current;
            if (vid) {
              vid.muted = false;
              vid.currentTime = 0;
              vid.loop = false;
              vid.play();
            }
            setPlayingVideo2(true);
          }} aria-label="Reproducir video con sonido" data-id="element-96">
                <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(249, 115, 22, 0.85)',
              boxShadow: '0 0 20px rgba(249, 115, 22, 0.6)'
            }} data-id="element-97">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white" data-id="element-98">
                    <polygon points="8,5 20,12 8,19" data-id="element-99" />
                  </svg>
                </div>
              </button>}
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIAL CARDS MASONRY ===== */}
      <section className="py-12 px-4" style={{
      backgroundColor: '#000000'
    }} data-id="element-100">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-101">
          <div className="text-xl mb-3 tracking-widest" style={{
          color: '#F97316'
        }} data-id="element-102">
            ★★★★★
          </div>
          <h2 className="text-white text-2xl font-extrabold leading-tight max-w-sm mx-auto" data-id="element-103">
            HERREROS REALES QUE YA
            <br data-id="element-104" />
            DUPLICARON LA FACTURACIÓN
          </h2>
          <p className="text-gray-400 text-sm mt-3" data-id="element-105">
            Gracias al Sistema Maestro de Herrería
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="columns-2 gap-4 space-y-4" data-id="element-106">
          {/* Card 1 */}
          <div className="break-inside-avoid bg-white rounded-2xl p-4 mb-4" style={{
          boxShadow: '0 0 35px rgba(249, 115, 22, 0.6)'
        }} data-id="element-107">
            <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771521241/Disen-o-sin-ti-tulo-_36_s4tb3n.png" alt="" className="rounded-xl mb-3 w-full block" data-id="element-108" />
            <div style={{
            color: '#F97316'
          }} className="mb-2" data-id="element-109">
              ★★★★★
            </div>
            <h3 className="font-bold text-black mb-1" data-id="element-110">
              Empecé a cobrar lo que realmente valgo
            </h3>
            <p className="text-gray-700 text-sm" data-id="element-111">
              Antes hacía trabajos chicos. Con este sistema aprendí a
              presupuestar bien y ahora acepto proyectos más grandes sin miedo.
            </p>
            <p className="text-xs mt-3 text-gray-500 font-semibold" data-id="element-112">
              Martín G. (Cliente verificado)
            </p>
          </div>

          {/* Card 2 */}
          <div className="break-inside-avoid bg-white rounded-2xl p-4 mb-4" style={{
          boxShadow: '0 0 35px rgba(249, 115, 22, 0.6)'
        }} data-id="element-113">
            <div style={{
            color: '#F97316'
          }} className="mb-2" data-id="element-114">
              ★★★★★
            </div>
            <h3 className="font-bold text-black mb-1" data-id="element-115">Todo mucho más claro</h3>
            <p className="text-gray-700 text-sm" data-id="element-116">
              Tenía experiencia pero desorden. Ahora sigo un sistema paso a paso
              y la facturación se duplicó en pocos meses.
            </p>
            <p className="text-xs mt-3 text-gray-500 font-semibold" data-id="element-117">
              Federico S. (Cliente verificado)
            </p>
          </div>

          {/* Card 3 */}
          <div className="break-inside-avoid bg-white rounded-2xl p-4 mb-4" style={{
          boxShadow: '0 0 35px rgba(249, 115, 22, 0.6)'
        }} data-id="element-118">
            <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771521241/Disen-o-sin-ti-tulo-_39_shmsvr.png" alt="" className="rounded-xl mb-3 w-full block" data-id="element-119" />
            <div style={{
            color: '#F97316'
          }} className="mb-2" data-id="element-120">
              ★★★★★
            </div>
            <h3 className="font-bold text-black mb-1" data-id="element-121">
              Ordené el taller y crecí
            </h3>
            <p className="text-gray-700 text-sm" data-id="element-122">
              Pasé de improvisar a trabajar con planificación. Bajé tiempos de
              fabricación y aumenté mis márgenes.
            </p>
            <p className="text-xs mt-3 text-gray-500 font-semibold" data-id="element-123">
              Javier R. (Cliente verificado)
            </p>
          </div>

          {/* Card 4 */}
          <div className="break-inside-avoid bg-white rounded-2xl p-4 mb-4" style={{
          boxShadow: '0 0 35px rgba(249, 115, 22, 0.6)'
        }} data-id="element-124">
            <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771521240/Disen-o-sin-ti-tulo-_40_a69aou.png" alt="" className="rounded-xl mb-3 w-full block" data-id="element-125" />
            <div style={{
            color: '#F97316'
          }} className="mb-2" data-id="element-126">
              ★★★★★
            </div>
            <h3 className="font-bold text-black mb-1" data-id="element-127">
              Recuperé la inversión en un solo proyecto
            </h3>
            <p className="text-gray-700 text-sm" data-id="element-128">
              Con un trabajo bien presupuestado recuperé todo. Después todo fue
              ganancia.
            </p>
            <p className="text-xs mt-3 text-gray-500 font-semibold" data-id="element-129">
              Lucas P. (Cliente verificado)
            </p>
          </div>

          {/* Card 5 */}
          <div className="break-inside-avoid bg-white rounded-2xl p-4 mb-4" style={{
          boxShadow: '0 0 35px rgba(249, 115, 22, 0.6)'
        }} data-id="element-130">
            <div style={{
            color: '#F97316'
          }} className="mb-2" data-id="element-131">
              ★★★★★
            </div>
            <h3 className="font-bold text-black mb-1" data-id="element-132">
              Subí el nivel profesional
            </h3>
            <p className="text-gray-700 text-sm" data-id="element-133">
              Ahora vendo muebles industriales mejor terminados y con precios
              justos. Trabajo más tranquilo y gano más.
            </p>
            <p className="text-xs mt-3 text-gray-500 font-semibold" data-id="element-134">
              Sebastián F. (Cliente verificado)
            </p>
          </div>

          {/* Card 6 */}
          <div className="break-inside-avoid bg-white rounded-2xl p-4 mb-4" style={{
          boxShadow: '0 0 35px rgba(249, 115, 22, 0.6)'
        }} data-id="element-135">
            <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771521240/fee6b92aff3d1bb23295eb0cc23a173c-_1_atvdno.jpg" alt="" className="rounded-xl mb-3 w-full block" data-id="element-136" />
            <div style={{
            color: '#F97316'
          }} className="mb-2" data-id="element-137">
              ★★★★★
            </div>
            <h3 className="font-bold text-black mb-1" data-id="element-138">Dejé de improvisar</h3>
            <p className="text-gray-700 text-sm" data-id="element-139">
              Antes cortaba sin seguridad. Hoy sigo planos exactos y reduzco
              desperdicio de material.
            </p>
            <p className="text-xs mt-3 text-gray-500 font-semibold" data-id="element-140">
              Nicolás E. (Cliente verificado)
            </p>
          </div>
        </div>
      </section>

      {/* ===== FAQ SECTION ===== */}
      <section className="py-14 px-4" style={{
      backgroundColor: '#000000'
    }} data-id="element-141">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-142">
          <h2 className="text-white text-2xl font-extrabold tracking-tight" data-id="element-143">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-16 h-1 rounded-full mx-auto mt-4" style={{
          backgroundColor: '#F97316'
        }} data-id="element-144" />
        </div>

        {/* FAQ Items */}
        <div className="space-y-4 max-w-md mx-auto" data-id="element-145">
          {[{
          q: '¿Cómo recibo el sistema y qué incluye?',
          a: 'Recibís acceso inmediato 100% digital apenas confirmás la compra. Incluye el Sistema Maestro de Herrería completo + 8 bonos exclusivos con planos, presupuestos, organización de taller y más.'
        }, {
          q: '¿Necesito experiencia previa en herrería?',
          a: 'No. Muchos alumnos comenzaron desde cero sin experiencia en herrería ni carpintería metálica. El sistema está explicado paso a paso.'
        }, {
          q: '¿En qué formato recibo el material?',
          a: 'Todo el contenido se entrega en formato digital descargable y acceso online. Podés verlo desde celular, tablet o computadora.'
        }, {
          q: '¿Cuánto tiempo tengo acceso?',
          a: 'El acceso es de por vida. Pagás una sola vez y podés ingresar siempre que quieras.'
        }, {
          q: '¿Puedo fabricar y vender los proyectos?',
          a: 'Sí. El objetivo del sistema es que puedas fabricar, presupuestar correctamente y vender los proyectos con mayor margen de ganancia.'
        }, {
          q: '¿Qué pasa si siento que no es para mí?',
          a: 'Tenés garantía de 7 días. Si no te convence, pedís devolución y recuperás el 100% del dinero.'
        }].map((item, i) => <div key={i} className="rounded-2xl overflow-hidden" style={{
          backgroundColor: '#000000',
          border: '1px solid rgba(249, 115, 22, 0.3)',
          boxShadow: '0 0 25px rgba(249, 115, 22, 0.5)'
        }} data-id="element-146">
              <button className="w-full flex justify-between items-center p-5 text-left text-white font-semibold text-sm border-0 cursor-pointer" style={{
            backgroundColor: 'transparent'
          }} onClick={() => setOpenFaq(openFaq === i ? null : i)} type="button" data-id="element-147">
                {item.q}
                <span className="text-xl flex-shrink-0 ml-3 transition-transform duration-300" style={{
              color: '#F97316',
              transform: openFaq === i ? 'rotate(45deg)' : 'rotate(0deg)'
            }} data-id="element-148">
                  +
                </span>
              </button>
              {openFaq === i && <div className="px-5 pb-5 text-gray-300 text-sm leading-relaxed" data-id="element-149">
                  {item.a}
                </div>}
            </div>)}
        </div>
      </section>

      {/* ===== FINAL CLOSING BLOCK ===== */}
    </>;
}